/**
 * JsBridg
 * 管理 iframe 和 主页面的通讯
 */

import { gameEventMap } from '~/components/Game/ts/data'

// 常量函数名
const funName = {
  GET_UID: 'getUid',
  GET_ROOMID: 'getRoomId',
  GET_TICKET: 'getTicket',
  GET_LANGUAGE: 'getLanguage',
  CLOSE_WEB_VIEW: 'closeWebView', // 关闭游戏窗口
  CLOSE_WIN: 'closeWin', // 关闭游戏窗口
  SHOW_LOADING: 'showLoading', // 显示加载中
  CLOSE_LOADING: 'closeLoading', // 关闭加载中
  TO_PAGE: 'toPage', // 跳转页面： 充参： Number: 对应pages的type,
  OPEN_RECHARGE_POPUP: 'openRechargePopup', // 打开充值弹窗
  TRACK_BETTING_EVENT: 'trackBettingEvent' // 游戏触发下注事件
}
// 常量页面跳转
const pagesType = {
  PAGE_RECHARGE: 1
}
const pagesInfo = {
  [pagesType.PAGE_RECHARGE]: {
    TYPE: 1,
    PATH: '/recharge'
  } //充值页面
}

// 收到子页面的监听 onMessage
function onMessage(event) {
  console.log('onMessage', event)
  // 先判断是否是子页面过来的信息
  if (event.data.funName) {
    // 获取 webView DOM
    const webViewDom = document.getElementById(webViewId)

    const router = useRouter()
    const route = useRoute()

    const publicStore = usePublicStore()
    const roomStore = useRoomStore()
    const languageStore = useLanguageStore() // 此字段不限制于接口，所以可以直接使用

    // 需要回调的数据
    const callbackData = {
      funName: event.data.funName,
      callbackFunName: event.data.callbackFunName,
      data: {} as { [prop: string]: string | number }
    }
    // 判断函数名，区分，处理请写这里
    switch (event.data.funName) {
      // 获取uid
      case funName.GET_UID:
        if (localStorage.getItem('loginInfo')) {
          const loginInfo = JSON.parse(
            localStorage.getItem('loginInfo') as string
          )
          callbackData.data.uid = loginInfo.uid
        }
        break
      // 获取roomid
      case funName.GET_ROOMID:
        callbackData.data.roomId = roomStore.roomId || 0
        break

      // 获取ticket
      case funName.GET_TICKET:
        if (localStorage.getItem('ticket')) {
          callbackData.data.ticket = localStorage.getItem('ticket') || ''
        }
        break

      // 获取language
      case funName.GET_LANGUAGE:
        if (languageStore.languageInfo.value) {
          callbackData.data.language = languageStore.languageInfo.value || ''
        }
        break
      // 关闭窗口
      case funName.CLOSE_WEB_VIEW:
      case funName.CLOSE_WIN:
        publicStore.setWebViewPopupConfig({ isShow: false, popupClass: '' })
        break
      // 显示加载中
      case funName.SHOW_LOADING:
        showLoadingToast({
          message: '',
          forbidClick: false,
          duration: 0
        })
        break
      // 关闭加载中
      case funName.CLOSE_LOADING:
        closeToast()
        break
      // 跳转界面
      case funName.TO_PAGE:
        // 跳转前需要先关闭webView
        publicStore.setWebViewPopupConfig({ isShow: false, popupClass: '' })

        // 如果是在直播页面，想关闭退出确认框，直接跳转
        if (route.path === '/room/live') {
          roomStore.setIsShowLiveRouteLeavDialog(false)
        }

        // 跳转
        router.push({
          path: pagesInfo[event.data.data].PATH,
          replace: route.path === '/room/call' // 如果当前是/room/call页面就需要特殊处理，先关闭当前页面
        })
        break
      // 打开充值弹窗
      case funName.OPEN_RECHARGE_POPUP:
        publicStore.setShowRechargePopup(true)
        break
      // 游戏触发下注事件
      case funName.TRACK_BETTING_EVENT:
        // 下注埋点
        gameEventMap[event.data.data] &&
          eventTracking.eventLog(
            gameEventMap[event.data.data as keyof typeof gameEventMap].betting
          )
        break
    }

    // 查看是否需要回调
    if (webViewDom && event.data.callbackFunName) {
      event.data.callbackFunName &&
        webViewDom['contentWindow'].postMessage(callbackData, '*')
    }
  }
}

// webViewId
export const webViewId = 'webView'

// 开启message监听
export function startMessage() {
  window.addEventListener('message', onMessage)
}

// 移除message监听
export function removeMessage() {
  window.removeEventListener('message', onMessage, false)
}

export default {
  webViewId,
  startMessage,
  removeMessage
}
